import { defineMessages } from 'react-intl';

export default defineMessages({
  amount: {
    id: 'sentinel.components.recentDepositsAccordion.amount',
    defaultMessage: 'Amount',
  },
  bankAccount: {
    id: 'sentinel.components.recentDepositsAccordion.bankAccount',
    defaultMessage: 'Bank Account',
  },
  routingNumber: {
    id: 'sentinel.components.recentDepositsAccordion.routingNumber',
    defaultMessage: 'Routing Number',
  },
  transferDate: {
    id: 'sentinel.components.recentDepositsAccordion.transferDate',
    defaultMessage: 'Transfer Date',
  },
});



// WEBPACK FOOTER //
// ./src/components/RecentDepositsPanel/messages.js